import { styled } from '@mui/system';

export const IconContainer = styled('div')(({ theme }) => ({
    position: 'absolute',
    right: '35px',
    top: '20px',
    [theme.breakpoints.down('md')]: {
        right: '10px',
        top: '15px',
        '& > svg': {
            fontSize: '1.5rem',
        },
    },
}));

export const FooterLinks = styled('div')(({ theme }) => ({
    marginTop: '15px',
    marginLeft: '5%',
    color: '#FFF',
    [theme.breakpoints.down('md')]: {
        '&': {
            display: 'none',
        },
    },
}));

export const FooterLinksMobile = styled('div')(({ theme }) => ({
    color: '#FFF',
    marginTop: '15px',
    [theme.breakpoints.up('md')]: {
        '&': {
            display: 'none',
        },
    },
    [theme.breakpoints.down('md')]: {
        '&': {
            display: 'flex',
        },
    },
}));
